import messages from './CreateAccount.json'
import AppNavbar from 'src/components/Dashboard/Layout/AppNavbar/AppNavbar.vue'
import AppFooter from 'src/components/Dashboard/Layout/AppFooter/AppFooter.vue'
import CreerUtilisateur from 'src/components/Dashboard/Views/CreerUtilisateur/CreerUtilisateur.vue'

export default {
  name: 'CreateAccount',
  i18n: messages,
  components: {
    AppNavbar,
    AppFooter,
    CreerUtilisateur,
  },
}
